function evaluate(expr, nVars, nClauses, maxDomains) {
    if(expr === "")
        return true;
    let e = expr.split('v').join(nVars).split('c').join(nClauses)
    if(maxDomains !== "")
        e = e.split("d").join(maxDomains);
    try {
        return  eval(e);
    } catch (e) {
        if (e instanceof SyntaxError) {
            return true;
        } else {
            throw e;
        }
    }
}

function simulate_evaluate(expr) {
    const e = expr.split('v').join(100).split('c').join(100).split('d').join(100);
    try {
        eval(e);
        return true;
    } catch (e) {
        if (e instanceof SyntaxError) {
            return false;
        } else {
            throw e;
        }
    }
}

function isFiltered(filters, benchmark) {
    let d = ""
    if(filters.name == null) filters.name = ""
    if(benchmark.info_domains !== undefined) {
        let tmp = benchmark.info_domains.split("(")[1].split(":")
        tmp = tmp[tmp.length-2].split("#")
        d = tmp[tmp.length-1]
    }
    if(filters.name == null)
        filters.name = ""
    if (benchmark.name !== undefined  && filters.name.length >= 2 && benchmark.name.includes(filters.name) === false)
        return false;
    if (filters.optim === false && filters.selection !== "ALL" && benchmark.status !== filters.selection)
        return false;
    if (filters.optim === false  && evaluate(filters.formula, benchmark.nb_variables, benchmark.nb_clauses, d) === false)
        return false;
    if (filters.optim && benchmark.nb_constraints !== undefined &&
        evaluate(filters.formula, benchmark.nb_variables, benchmark.nb_constraints, d) === false)
        return false;
    if (filters.optim && filters.type !== "ALL" && benchmark.type.startsWith(filters.type) === false)
        return false;
    if (filters.optim && filters.selection !== "ALL" && ((filters.selection === "OPT" && benchmark.optim === 0) || (filters.selection === "?" && benchmark.optim === 1)))
        return false;
    for(let t of filters.forbidfamilies) {
        if(benchmark.family == t)
            return false;
    }
    if(filters.constraints !== undefined) {
        for(let t of filters.constraints.types )
               if (benchmark.info_constraints.includes(t) !== filters.constraints.willing)
                   return false;
    }
    return true;
}

function cleanJSON(data, convert) {
    for(let i = 0; i < data.length; i++) {
        for(const key of convert)
            if(data[i][key] != null)
                data[i][key] = parseInt(data[i][key])
    }
    return data
}

function numberWithSpaces(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "&nbsp;")
}

function removeSpaces(x) {
    return x.replace(/&nbsp;/g, '')
}

function nbInFamily(benchmarks, f, filters) {
    let nb = 0
    for(let b of benchmarks) {
        if(b.family === f && isFiltered(filters, b))
            nb++
    }
    return nb
}

export {evaluate, simulate_evaluate, isFiltered, cleanJSON, numberWithSpaces, removeSpaces, nbInFamily}